export function getCalendarGridAgendaDays({ days, itemsByDay }) {
  return days.filter(day => itemsByDay[day.date]?.length > 0)
}

export function getHasCalendarGridAgendaDays(agendaDays) {
  return agendaDays.length > 0
}

export function getCalendarGridAgendaMessage({ message, t }) {
  return message ?? { text: t('Calendar.EmptyAgendaKey') }
}
